export const upsellings = {
    text1: "Usługi",
    text2: "Zarządzaj swoimi usługami",
    text3: "Lista usług",
    text4: "Dostawcy",
    text5: "Lista usług, które zobaczą goście",
    text6: "Zarejestruj usługę",
    text7: "Nazwa",
    text8: "Utworzono",
    text9: "Status",
    text10: "aktywna",
    text11: "nieaktywna",
    text12: "Edytuj usługę",
    text13: "Usuń usługę",
    text14: "Nie znaleziono żadnych usług.",
    text15: "Zmiana została zapisana.",
    text16: "Czy na pewno usunąć usługę",
    text17: "Zapisane dane zostaną utracone",
    text18: "Usuń usługę",
    text19: "Anuluj",
    text20: "Usunięto pomyślnie.",
    text21: "Utwórz usługę",
    text22: "Informacje o usłudze",
    text23: "Wprowadź główne informacje o usłudze, widoczne na karcie.",
    text24: "Wszystkie obiekty",
    text25: "Wybierz obiekt *",
    text26: "Wpisz nazwę",
    text27: "Nazwa Twojej usługi *",
    text28: "Automatyczne",
    text29: "Ręczne",
    text30: "Rodzaj potwierdzenia",
    text31: "Tytuł usługi",
    text32: "Wpisz tytuł *",
    text33: "Check-in/check-out",
    text34: "Transfer",
    text35: "F&B",
    text36: "Sezonowe",
    text37: "Rodzinne",
    text38: "Romantyczne",
    text39: "SPA i zdrowie",
    text40: "Sztuka i kultura",
    text41: "Aktywności",
    text42: "Usługi",
    text43: "Inne",
    text44: "Kategoria *",
    text45: "Usługa wewnętrzna",
    text46: "Dostawca *",
    text47: "Opis",
    text48: "Wpisz opis swojej usługi *",
    text49: "Cena",
    text50: "Wybierz rodzaj ceny i określ, ile goście zapłacą za tę ofertę.",
    text51: "Wpisz liczbę",
    text52: "Za sztukę",
    text53: "Za osobę",
    text54: "Za grupę",
    text55: "Za dzień",
    text555: "Za godzinę",
    text56: "Cena za",
    text57: "Zdjęcie",
    text58: "Prześlij zdjęcie, które pojawi się w nagłówku karty.",
    text59: "Zapisz usługę",
    text60: "Wczytywanie ...",
    text61: "Usługa została utworzona.",
    text62: "Lista dostawców",
    text63: "Dodaj dostawcę",
    text64: "ID",
    text65: "Nazwa",
    text66: "E-mail",
    text67: "Telefon",
    text68: "Edytuj dostawcę",
    text69: "Usuń dostawcę",
    text70: "Zarejestruj dostawcę",
    text71: "Dodaj ",
    text72: "dostawców ",
    text73: "do swojej listy, aby móc tworzyć z nimi nowe oferty.",
    text74: "Wpisz nazwę",
    text75: "Nazwa dostawcy *",
    text76: "Kraj",
    text77: "Błąd",
    text78: "Wpisz numer",
    text79: "Telefon *",
    text80: "Adres e-mail *",
    text81: "Adres",
    text82: "Dodaj dostawcę",
    text83: "Utworzono pomyślnie.",
    text84: "Czy na pewno usunąć tego dostawcę?",
    text85: "Zapisane dane zostaną utracone",
    text86: "Usuń dostawcę",
    text87: "Usunięto pomyślnie.",
    text96: 'Zarządzaj swoimi subskrypcjami i fakturami',
    
    // Poprawki
    p1: "Cena na zapytanie",
};
